import React from 'react';
import { styled } from '@mui/material/styles';
import SectionTitle from '../../../components/SectionTitle';
import { Container, Typography } from '@mui/material';

const SectionRoot = styled('div')(({ theme }) => ({
    padding: '50px 0',
    margin: '0 auto',
    maxWidth: '1200px'
}));

const LinkStyled = styled('a')(({ theme }) => ({
    color: '#D7412E',
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
    },
}));


const CookiePolicyContent = () => {
    return (
            <SectionRoot>
                <Typography variant="h2" style={{ marginBottom: '20px' }}>
                    Introduction
                </Typography>
                <Typography variant="body1">
                    This Cookie Policy explains how CIA ("we", "us", "our") uses cookies and similar 
                    technologies on our website,{' '}
                    <LinkStyled href="https://cia.co.za" target="_blank" rel="noopener noreferrer">
                        https://cia.co.za
                    </LinkStyled>.
                    {' '}(the "Website"). By continuing to browse or use our Website, you agree to our use 
                    of cookies in accordance with this policy.
                </Typography>

                <Typography variant="h2" style={{ marginBottom: '20px', marginTop: '30px' }}>What Are Cookies? </Typography>
                <Typography variant="body1">
                    Cookies are small text files that are stored on your device (computer, tablet, or 
                    mobile phone) when you visit a website. Cookies help websites recognise your device 
                    and remember certain information about your visit, such as preferences or interactions, 
                    to improve functionality and user experience. <br /><br />
                    Cookies do not give us access to your device, and they do not contain viruses or 
                    harmful software.
                </Typography>

                <Typography variant="h2" style={{ marginBottom: '20px', marginTop: '30px' }}>Who This Policy Applies To </Typography>
                <Typography variant="body1">
                    This policy applies to all visitors and users of the CIA Website.
                </Typography>

                <Typography variant="h2" style={{ marginBottom: '20px', marginTop: '30px' }}>Do You Have to Accept Cookies? </Typography>
                <Typography variant="body1">
                    <>
                        You are not required to accept cookies to use our Website. You can choose to block 
                        or delete cookies through your browser settings at any time. However, please note 
                        that disabling certain cookies may affect the functionality, performance, or 
                        availability of some features on the Website.
                        <br /><br />
                        More information about managing cookies can be found at{' '}
                        <LinkStyled href="https://www.allaboutcookies.org/" target="_blank" rel="noopener noreferrer">
                            https://www.allaboutcookies.org/
                        </LinkStyled>.
                    </>
                </Typography>

                <Typography variant="h2" style={{ marginBottom: '20px', marginTop: '30px' }}>Why We Use Cookies </Typography>
                <Typography variant="body1">
                    We use cookies to: <br />
                    <ul>
                        <li>Ensure the Website operates correctly and securely.</li>
                        <li>Monitor and analyse website performance and usage.</li>
                        <li>Improve the design, functionality, and content of the Website.</li>
                        <li>Understand how visitors interact with the Website.</li>
                        <li>Enable interactive features and user-friendly experiences.</li>
                        <li>Protect the Website from misuse, spam, and fraudulent activity.</li>
                    </ul>
                </Typography>

                <Typography variant="h2" style={{ marginBottom: '20px', marginTop: '30px' }}>Types of Cookies We Use </Typography>
                <Typography variant="body1">
                    <ol>
                        <h3><li>Strictly Necessary Cookies</li></h3>
                        These cookies are essential for the operation of the Website. They enable core functionality such as page navigation, 
                        access to secure areas, and protection against security threats. 
                        Without these cookies, the Website may not function properly.
                        <h3><li>Performance and Analytics Cookies</li></h3>
                        These cookies collect information about how visitors use the Website, such as which pages are visited most often, 
                        how users move around the site, and whether errors occur. The information collected is aggregated and 
                        anonymised and is used solely to improve the performance and usability of the Website.
                        <h3><li>Functionality Cookies</li></h3>
                        Functionality cookies allow the Website to remember choices you make and support interactive features. 
                        These cookies help provide a smoother and more personalised experience, such as remembering information during a 
                        session or enabling interactive tools.
                        <h3><li>Security Cookies</li></h3>
                        Security-related cookies are used to help protect the Website and its users. These cookies assist in identifying legitimate users, 
                        preventing automated abuse, detecting suspicious activity, and maintaining the overall security and integrity of the Website.
                    </ol>
                </Typography>  

                <Typography variant="h2" style={{ marginBottom: '20px', marginTop: '30px' }}>How to Control or Delete Cookies </Typography>
                <Typography variant="body1">
                    Most web browsers automatically accept cookies, but you can modify your browser settings to block or delete cookies if you prefer. 
                    You can also configure your browser to notify you when cookies are being placed on your device. 
                    You can read how to do this for popular browsers by following these links: <br />
                    <ul>
                        <li>
                            <LinkStyled href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox" target="_blank" rel="noopener noreferrer">
                                Firefox
                            </LinkStyled>.
                        </li>
                        <li>
                            <LinkStyled href="https://support.google.com/accounts/answer/32050?co=GENIE.Platform%3DDesktop&hl=en" target="_blank" rel="noopener noreferrer">
                                Google Chrome
                            </LinkStyled>.
                        </li>
                       <li>
                            <LinkStyled href="https://support.microsoft.com/en-gb/windows/manage-cookies-in-microsoft-edge-view-allow-block-delete-and-use-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer">
                                Microsoft Edge
                            </LinkStyled>.
                        </li>
                       <li>
                        <LinkStyled href="https://support.apple.com/en-us/105082" target="_blank" rel="noopener noreferrer">
                                Safari
                            </LinkStyled>.
                        </li>
                    </ul>
                </Typography>              

            </SectionRoot>
    );
};

export default CookiePolicyContent;
